import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/faro-dialog";
import { SanitizedHtmlTag } from "@components/common/sanitized-html-tag";
import { getErrorDisplayMarkup } from "@context-providers/error-boundary/error-boundary-utils";
import { ErrorWithTitle } from "@context-providers/error-boundary/error-types";
import { WarningIcon, Dialog } from "@flat-ui";
import { Typography } from "@mui/material";
import { removeOne } from "@store/errors/errors-slice";
import { useAppDispatch } from "@store/store-helper";

interface Props {
  /** The error to be show in dialog */
  error: ErrorWithTitle;

  /** Handler to close the dialog */
  onClose(): void;
}

/**
 * Displays an error message in a Dialog with a close button.
 */
export function ErrorDialog({ error, onClose }: Props): JSX.Element {
  const dispatch = useAppDispatch();

  function onCloseHandler(): void {
    dispatch(removeOne(error.id));
    onClose();
  }

  return (
    <Dialog
      key={error.id}
      open={true}
      onConfirm={onCloseHandler}
      title={
        <>
          <WarningIcon
            sx={{
              marginRight: "10px",
            }}
          />
          An unexpected error occurred
        </>
      }
      confirmText="OK"
    >
      <>
        <Typography variant="h6" mt={SPACE_ELEMENTS_OF_MODAL}>
          {error.title}
        </Typography>

        <Typography component="div" gutterBottom>
          <b>Developer Error Message:</b>
          <SanitizedHtmlTag markup={getErrorDisplayMarkup(error.error)} />
        </Typography>
      </>
    </Dialog>
  );
}
